export default __webpack_public_path__ + "static/media/ic_gray_info.cded2dba.svg";